import AddCardForm from '../../screens/PaymentScreen/AddCardForm';

const AddCard = ({ onAdded }: { onAdded: (method: string) => void }) => {
  return <AddCardForm onSubmitEnd={onAdded} />;
};

export default AddCard;
